<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <div class="text-center">{{ message }}</div>

      <textarea class="h-28 mt-6" id="reason" type="text" v-model="reason" />

      <primary-button
        class="mt-4 bg-error-500 hover:bg-error-600"
        :loading="loading"
        @buttonClicked="confirm"
        >Confirmar
      </primary-button>

      <button
        v-if="!loading"
        class="mt-4 mx-auto w-full system-button"
        @click.prevent="close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reason: "",
    };
  },

  props: {
    loading: false,
    message: String,
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirm() {
      this.$emit("confirm", this.reason);
    },
  },
};
</script>